import { appSettings } from '@/settings/app-settings';

import { updateAssetById } from './asset-manager-apis';
import { uploadS3Image } from './s3-api';
import { uploadMultipleS3Image } from './s3-api';

export async function updateProductItem(api: any, editItem: any, values: any, client: any) {
  let existingData = values.existingImages || [];

  return new Promise<boolean>((resolve, reject) => {
    function update(imageURL = '') {
      if (editItem !== null) {
        const props: {
          [key: string]: any;
        } = {};
        // if (
        //   [
        //     LISTITEM_TYPE_SHOPIFY,
        //     LISTITEM_TYPE_BOOKABLE_FIXED_SELECTION,
        //     LISTITEM_TYPE_BOOKABLE_FREE_SELECTION,
        //     LISTITEM_TYPE_BOOKABLE_WITH_DURATION,
        //     LISTITEM_TYPE_BOOKABLE_EVENT,
        //     LISTITEM_TYPE_MEMBERSHIP,
        //     LISTITEM_TYPE_BLOG,
        //     LISTITEM_TYPE_BOLDER_ASSET_PRODUCT,
        //     LISTITEM_TYPE_BOLDER_ASSET_BOOKING
        //   ].includes(editItem.object?.product_type)
        // ) {
        props.name = values.title;
        if (values.price) {
          props.price = parseFloat(values.price?.replace(/[^0-9.]/g, ''));
        }
        // }

        if (imageURL) {
          props.bannerImage = imageURL;
          props.thumbnailImage = imageURL;
        }

        if (values.shortDescription) {
          props.shortDescription = values.shortDescription;
        }

        if (values.longDescription) {
          props.longDescription = values.longDescription;
        }

        // if (values?.product_is_active) {
        //   props.product_is_active = values.product_is_active;
        // }

        // if (editItem.schemaRefId === LISTITEM_TYPE_BOOKABLE) {
        //   props.price = values.price;
        // } else if (editItem.connection !== LISTITEM_CONNECTION_BLOG) {
        //   // props.Price = values.price;
        // }

        updateAssetById(appSettings.api, editItem._id, props)
          .then(() => {
            resolve(true);
          })
          .catch((error: any) => {
            reject(error);
          });
      } else {
        reject(false);
      }
    }

    function updateGalleryImage(imageURL: string[] = []) {
      if (editItem !== null) {
        const props: {
          [key: string]: any;
        } = {};
        props.name = values.title;
        // if (values.price) {
        //   props.price = parseFloat(values.price?.replace(/[^0-9.]/g, ""));
        // }
        // }

        if (imageURL) {
          props.images = imageURL;
        }

        // if (values.shortDescription) {
        //   props.shortDescription = values.shortDescription;
        // }

        // if (values.longDescription) {
        //   props.longDescription = values.longDescription;
        // }

        updateAssetById(appSettings.api, editItem._id, props)
          .then(() => {
            resolve(true);
          })
          .catch((error: any) => {
            reject(error);
          });
      } else {
        reject(false);
      }
    }

    if (values.image) {
      uploadS3Image(api, values.image)
        .then((response) => {
          update(response?.data?.result?.fileName);
        })
        .catch((error) => {
          console.log(error);
          update();
        });
    } else {
      update();
    }

    if (values.galleryImages.length > 0) {
      // for (var i = 0; i < values.galleryImages.length; i++) {

      uploadMultipleS3Image(api, values.galleryImages)
        .then((response) => {
          response?.data?.result?.forEach((item: { fileName: any }) => {
            const newImageUrl = item.fileName;
            existingData = [...existingData, newImageUrl];
          });
          updateGalleryImage(existingData);
        })
        .catch((error) => {
          console.log(error);
          update();
        });

      // }
      // console.log(existingData);
      // updateGalleryImage(existingData);
    } else {
      // update();
    }
  });
}

export function toggleProductStatus(productId: string, status: number) {
  return new Promise<boolean>((resolve, reject) => {
    updateAssetById(appSettings.api, productId, { status: Number(status) })
      .then(() => {
        resolve(true);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}
